<template>
    <div class="menu-list">
        <div v-for="(item, index) in state.list" :key="index">
            <div class="father-box" @click="changeShow(index)">
                <!-- <span :class="['icons', item.icon_type]"></span> -->
                {{ item.title }}
                <span :class="['icon-arrowup icons icons-right', {'rotated': item.show}]"></span>
            </div>
            <el-collapse-transition>
                <div v-show="item.show && item.sub_list && item.sub_list.length">
                    <div
                        :class="['son-box', { 'active': (item.fater_id == props.fater_id && sitem.son_id == props.son_id) || (props.title == sitem.son_title) }]" 
                        v-for="(sitem, sindex) in item.sub_list" 
                        :key="sindex"
                        @click="changeProtocal(item, sitem)">
                        {{ sitem.son_title }}
                    </div>
                </div>
            </el-collapse-transition>
        </div>
    </div>
</template>

<script setup>
import { getProjectProtocalList } from "@/api/index"

import { defineProps, reactive, onMounted, defineEmits } from "vue"
import { useRouter } from "vue-router";

const router = useRouter()

const props = defineProps(['son_id', 'fater_id', 'title'])

const state = reactive({
    list: []
})

onMounted(() => {
    getList()
})

const getList = () => {
    getProjectProtocalList().then(res=> {
        if(res.status == 0) {
            state.list = res.data.map(item => {
                return {
                    title: item.group_name,
                    sub_list: item.agreement_list
                }
            })


            // state.list = [{
            //     title: '发布众筹注意事项',
            //     sub_list: [{
            //         son_title: '设置众筹概览项',
            //         fater_id: '9',
            //         son_id: '1'
            //     }]
            // },{
            //     title: '运营众筹项目必看',
            //     sub_list: [{
            //         son_title: '定期发布更新',
            //         fater_id: '8',
            //         son_id: '2'
            //     },{
            //         son_title: '项目评论运营',
            //         fater_id: '10',
            //         son_id: '1'
            //     }]
            // },{
            //     title: '站内曝光获取',
            //     sub_list: [{
            //         son_title: '站内广告位',
            //         fater_id: '10',
            //         son_id: '2'
            //     },{
            //         son_title: '商家活动',
            //         fater_id: '11',
            //         son_id: '1'
            //     }]
            // },{
            //     title: '站外曝光获取',
            //     sub_list: [{
            //         son_title: '种草活动',
            //         fater_id: '8',
            //         son_id: '1'
            //     },{
            //         son_title: '抽奖活动',
            //         fater_id: '8',
            //         son_id: '4'
            //     }]
            // }]

            state.list.map(item => {
                item.sub_list.map(sitem => {
                    if(sitem.son_id == props.son_id && sitem.fater_id == props.fater_id) {
                        item.show = true
                    }
                })
            })
        }
    })
}

const changeShow = (index) => {
    state.list[index].show = !state.list[index].show
}

const emit = defineEmits(['getDetail']);
const changeProtocal = (item, sitem) => {
    console.log(sitem)
    if(sitem.link) {
        window.open(sitem.link)
    } else {
        router.push(`/project/protocal/${sitem.fater_id}/${sitem.son_id}`)
        emit('getDetail', { fater_id: sitem.fater_id, son_id: sitem.son_id })
    }
}

</script>

<style lang="scss" scoped>
.menu-list {
    width: 240px;
    user-select: none;
    margin: 0 40px 0;
    padding: 30px 10px;
    background-color: #F8F8F8;
    border-radius: 8px;
    font-family: PingFang SC-Light, PingFang SC;
}
.father-box {
    font-size: 16px;
    font-weight: 500;
    padding: 20px 0 0 20px;
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;

    .icons {
        position: absolute;
        left: 10px;
        top: 22px;
        transition: transform 0.3s;
        &.icons-right {
            left: auto;
            right: 10px;
        }
        &.rotated {
            transform: rotate(180deg);
        }
    }
}
.son-box {
    cursor: pointer;
    line-height: 22px;
    padding: 5px 0 5px 30px;
    font-size: 14px;
    &:hover, &.active {
        background-color: #E8E8E8;
        font-weight: bold;
        border-radius: 4px;
    }
}
</style>
